var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"36px"},attrs:{"src":require("@/assets/images/logo/logo.jpeg")}})}
var staticRenderFns = []

export { render, staticRenderFns }